export default {
  dp: {
    navbar: {},
  },
};
